import { createGlobalStyle } from 'styled-components';

import CustomArial from '@/assets/fonts/arial-webfont.ttf';
import BitterBold from '@/assets/fonts/bitter-bold.woff';

const VariationStyles = createGlobalStyle`
  @font-face {
      font-family: 'CustomArial';
      src: url(${CustomArial});
  }
  @font-face {
      font-family: 'BitterBold';
      src: url(${BitterBold});
      font-weight: 900;
      font-style: normal;
    } 
  .generated-images-holder-var14 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 700px;
  }
  .image-holder-var14 {
    width: 100%;
    display: flex;
    position: relative;
    flex-direction: column;
    height: 883px;
  }
  .top-text-var14 {
    width: 100%;
    background-color: white;
    padding: 26px 35px 24px;
    font-size: 40px;
    line-height: 1.25;
    color: #1C2327;
    font-family: BitterBold;
    display: flex;
    align-items: center;
    gap: 40px;
  }
  .logo-icon-var14 {
    flex-shrink: 0;
    margin-top: -18px;
  }
  .bottom-text-var14 {
    position: absolute;
    bottom: 56px;
    margin: auto;
    left: 0;
    right: 0;
    font-size: 38px;
    line-height: 1.25;
    letter-spacing: 1.5px;
    color: #000;
    font-weight: 700;
    text-align: center;
    font-family: CustomArial;
    z-index: 1;
    p {
      position: relative;
      background-color: white;
      display: inline-block;
      margin: 0;
      padding: 14px 34px 17px;
    }
  }
  .triangle-icon-var14 { 
    position: absolute;
    bottom: -33px;
    left: -1px;
    display: block;
  }

  .full-image-var14 {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: relative;
  }
  .watermark-var14 {
    position: absolute;
    bottom: 14px;
    right: 10px;
    z-index: 1;
  }
`;

export default VariationStyles;
